import React, { useEffect, useContext } from 'react'
import ataquecardiaco from '../../../assets/images/ataquecardiaco.png'
import { GlobalContext } from '../../../contexts/GlobalContext'
import { useGeolocation } from '../../../hooks/useGeolocation'
import CardFlip from '../../../components/CardFlip'
import logo from '../../../assets/images/logo2.png'

export default function () {
	const { user } = useContext(GlobalContext)

	const { registerPageAccess } = useGeolocation()

	useEffect(() => {
		if (user) {
			registerPageAccess({
				pessoaId: user?.pessoa.id
			})
		} else {
			registerPageAccess()
		}
	}, [])

	return (
		<section className="pb-20 pt-10 md:pt-20 px-4 bg-gray-100">
			<div className="container mx-auto flex flex-col md:flex-row items-center">
				<div className="md:w-1/2 mb-10 md:pr-10 flex flex-col">
					<img src={logo} alt="" className="w-32 h-32 object-contain mb-8 self-center md:self-start" />

					<h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 lg:-mt-6 leading-tight animated fadeIn">
						Seus dados médicos sempre ao alcance
					</h1>

					<p className="text-lg text-gray-700 mb-8 animated fadeIn delay-200ms">
						O Prontuário é um aplicativo que dá acesso instantâneo aos seus
						dados clínicos durante um atendimento de emergência ou consulta médica.
					</p>

					<div className="flex gap-4 animated fadeIn delay-400ms">
						<a href="#planos" className="md:inline-flex px-8 py-4 md:px-4 md:py-2 bg-emerald-600 text-white rounded-md font-semibold border border-gray-300 hover:text-white hover:bg-emerald-700">
							Assine já
						</a>

						<a href="#beneficios" className="md:inline-flex px-8 py-4 md:px-4 md:py-2 rounded-md font-semibold border border-gray-300 text-slate-800">
							Saiba mais
						</a>
					</div>
				</div>

				<div className="w-screen sm:w-1/2 animated fadeIn delay-600ms relative h-[260px] md:h-[280px] lg:h-[420px]">
					<img
						src={ataquecardiaco}
						alt="Prontuário Médico - Cartão médico com QR Code"
						className="animate-float-image-hero w-screen sm:w-full sm:max-w-lg mx-auto rounded-lg shadow-suave object-contain"
						style={{
							boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)'
						}}
					/>

					<CardFlip
						frente="/assets/images/cartao%20frente.png"
						costa="/assets/images/cartao%20costa.png"
					/>
				</div>
			</div>
		</section>
	)
}
